import FeatureTile from './FeatureTile';
import UIFlex from 'UIComponents/layout/UIFlex';
import { jsx as _jsx } from "react/jsx-runtime";
const FeatureSurveyRow = ({
  className,
  features,
  onSelectionChange
}) => {
  return /*#__PURE__*/_jsx(UIFlex, {
    direction: "row",
    justify: "between",
    align: "center",
    gap: 32,
    className: className,
    children: features.map(surveyFeature => {
      return /*#__PURE__*/_jsx(FeatureTile, {
        feature: surveyFeature,
        onSelectionChange: onSelectionChange
      }, surveyFeature.featureKey);
    })
  });
};
export default FeatureSurveyRow;